import { render, staticRenderFns } from "./PVIEmailSettings.vue?vue&type=template&id=74326252&"
import script from "./PVIEmailSettings.vue?vue&type=script&lang=js&"
export * from "./PVIEmailSettings.vue?vue&type=script&lang=js&"
import style0 from "./PVIEmailSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/PVIEmailSettings.vue
// module id = null
// module chunks = 